import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
// import * as color from '../../../../business-component/chart/config/colors';

@Component({
  selector: 'bcac-zoom-icon',
  templateUrl: './bcac-zoom-icon.component.html',
  styleUrls: ['./bcac-zoom-icon.component.scss']
})
export class BcacZoomIconComponent implements OnInit {
  darkModeTextColor = '#EEE';
  defaultColor = '#323232'
  activeColor = '#1890ff'

  constructor() { }

  ngOnInit() {
  }


  iconType = "zoom_enlarge";
  @Input()
  set bcacIconType(value: string) {
    this.iconType = value;
  }

  tooltipTitle = "区域缩放";
  @Input()
  set bcacTooltipTitle(value: string) {
    this.tooltipTitle = value;
  }

  _bcacIsDarkMode: boolean = false
  _enlargeIconColor = this.defaultColor
  _backIconColor = this.defaultColor
  @Input()
  set bcacIsDarkMode(value: boolean) {
    this._bcacIsDarkMode = value;
    this.switchColor()
  }

  isBack: boolean = false //区域缩放还原状态
  isActive: boolean = false  //区域缩放点击状态
  @Input()
  set bcacZoomBackActive(value: boolean) {
    this.isBack = value
    this.switchColor()
  }


  //todo 切换颜色
  switchColor() {
    this._enlargeIconColor = this.isActive
      ? this.activeColor
      : (this._bcacIsDarkMode
        ? this.darkModeTextColor
        : this.defaultColor)

    this._backIconColor = this.isBack
      ? this.activeColor
      : (this._bcacIsDarkMode
        ? this.darkModeTextColor
        : this.defaultColor)
  }



  @Output()
  bcacZoomEmit = new EventEmitter<any>();
  clickZoom() {
    this.isActive = !this.isActive
    this.switchColor()
    const param = {
      type: this.iconType,
      active: this.isActive
    }
    this.bcacZoomEmit.emit(param);
  }


}
